import React from "react";
import CssClasses from "./OddButton.css";
import { GetConvertedOdds } from "../../../HOCs/Helpers/OddConverter";

const OddButton = props => {
  let classes = [CssClasses.button];
  let betInfo = props.betInfo;

  if (props.isMoreBets && props.moreBetsCount === 0) {
    return null;
  }

  if (props.offsetGeneric) {
    classes.push(CssClasses.offsetTopGeneric);
  }

  if (!props.isMoreBets && (betInfo === null || betInfo === undefined)) {
    //vrati ovo
    classes.push(CssClasses.notShownOddButton);

    return (
      //vrati ovo

      <div
        onClick={() => {
          props.onButtonClicked(0, 0);
        }}
        className={classes.join(" ")}
      >
        <span className={CssClasses.title} />
      </div>

      //vrati end

      // <div
      //   onClick={() => {
      //     props.onButtonClicked(0, 0);
      //   }}
      //   className={classes.join(" ")}
      // >
      //   <span
      //     className={[
      //       props.oddType === 5 ? CssClasses.smallerTitle : CssClasses.title
      //     ].join(" ")}
      //   >
      //     {GetConvertedOdds(props.oddType, Math.random() * 846 * 0.01)}
      //   </span>
      // </div>
    );
  }

  //printaj
  // console.log("BET INFO ", betInfo);
  // console.log("ACTIVE BETS ", props.activeBets);

  if (props.isMoreBets) {
    //btn for more bets
    classes = [CssClasses.moreBetTypesButton];

    if (props.offsetGeneric) {
      classes.push(CssClasses.offsetTopGeneric);
    }

    if (props.moreBetsClass) {
      classes.push(props.moreBetsClass);
    }

    if (props.isActive) {
      if (props.moreBetsActiveClass) {
        classes.push(props.moreBetsActiveClass);
      } else {
        classes.push(CssClasses.activeExtrasButton);
      }
    }

    return (
      <div
        onClick={() => {
          props.onButtonClicked(props.matchID);
        }}
        className={classes.join(" ")}
      >
        <span className={[CssClasses.title].join(" ")}>
          +{props.moreBetsCount}
        </span>
      </div>
    );
  }

  if (betInfo.isShown !== true) {
    classes.push(CssClasses.notShownOddButton);
  } else if (betInfo.isEnabled !== true) {
    classes.push(CssClasses.disabledOddButton);
  } else if (props.activeBets.includes(betInfo.id)) {
    classes.push(CssClasses.activeRegularButton);
  }

  //console.log("HAVE PROP ", props.activeBets);
  //console.log("BETINFOID ", betInfo.id);

  let oddsAnim = "";

  if (betInfo.isShown) {
    if (betInfo.changeDirection > 0) {
      classes.push(CssClasses.increasedOdds);
    } else if (betInfo.changeDirection < 0) {
      classes.push(CssClasses.decreasedOdds);
    }
  }

  return (
    <div
      onClick={() => {
        props.onButtonClicked(betInfo.matchID, betInfo.id);
      }}
      className={classes.join(" ")}
    >
      <span
        className={[
          props.oddType === 5 ? CssClasses.smallerTitle : CssClasses.title,
          oddsAnim
        ].join(" ")}
      >
        {GetConvertedOdds(props.oddType, betInfo.value)}
      </span>
    </div>
  );
};

export default OddButton;



// WEBPACK FOOTER //
// ./src/Components/UI/OddButton/OddButton.js